import { ITagProps } from 'src/components/Tag';
import getActivityStatus from './activityStatusUtils';

const tagsByStatus: Record<string, ITagProps> = {
  isAdvertisement: { color: 'info', children: 'KURSUS PÅ VEJ' },
  isFocus: { color: 'warning', children: 'FOKUS' },
  isCancelled: { color: 'danger', children: 'AFLYST' },
  lastEnrollmentDatePassed: {
    color: 'cancelled',
    children: 'TILMELDINGSFRIST UDLØBET'
  },
  lastChance: { color: 'danger', children: 'SIDSTE CHANCE' },
  success: { color: 'success', children: 'NYT' }
};

type ActivityStatus = ReturnType<typeof getActivityStatus>;

export const getActivityTag = (
  activity: Parameters<typeof getActivityStatus>[0]
): ITagProps | undefined => tagsByStatus[getActivityStatus(activity)];

export const getActivityStatusTag = (
  status: ActivityStatus
): ITagProps | undefined => tagsByStatus[status];



// WEBPACK FOOTER //
// ./src/utils/activityUtils.ts